import { Link } from "react-router";
import {
  buildViewHref,
  QUEST_VIEWS,
  type QuestsSearchParams,
  type QuestView,
} from "./questsUrl";
import styles from "./StatusFilter.module.css";

type StatusFilterProps = {
  searchParams: QuestsSearchParams;
  selected: QuestView;
  counts: Record<QuestView, number>;
};

const LABELS: Record<QuestView, string> = {
  ACTIVE: "Active",
  DRAFT: "Draft",
  PUBLISHED: "Published",
  ARCHIVED: "Archived",
};

// Reads as one control with four states rather than a filter plus a toggle:
// the views are mutually exclusive, so only one can be in force at a time, and
// nothing can contradict anything else.
export const StatusFilter = ({
  searchParams,
  selected,
  counts,
}: StatusFilterProps) => (
  <nav className={styles.filter} aria-label="Filter templates">
    {/* Link rather than a bare anchor, which would reload the document.
        History is pushed rather than replaced: switching view is a real
        navigation, and the back button should return to the previous one. */}
    {QUEST_VIEWS.map((view) => (
      <Link
        key={view}
        to={buildViewHref(searchParams, view)}
        preventScrollReset
        className={styles.option}
        data-selected={selected === view || undefined}
        aria-current={selected === view ? "true" : undefined}
      >
        {LABELS[view]}
        <span className={styles.count}>{counts[view]}</span>
      </Link>
    ))}
  </nav>
);
